import { useCallback, MouseEvent, ReactNode } from "react"
import { classNames } from "../Components"
import { CloseButton } from "./CloseButton"

interface OverlayProps {
  children: ReactNode;
  closeBackground?: boolean;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  closeCallback?: any;
  containerClassName?: string;
  hideBackground?: boolean;
  hideClose?: boolean;
  style?: string;
  title?: string;
}

export function OverlayNoClose() {
}

export function Overlay({ children, className, closeBackground, containerClassName, closeCallback, hideBackground, hideClose, style, title }: OverlayProps) {
  const onClick = useCallback((e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (closeCallback) {
      closeCallback(false);
    }
  }, [closeCallback]);
  // A dialog should never affect its container: stop every click inside the overlay
  // (title, body content, inputs, buttons) from bubbling up to ancestor click handlers,
  // regardless of whether it is otherwise handled.
  const stopPropagation = useCallback((e: MouseEvent) => {
    e.stopPropagation();
  }, []);
  return (
    <div className={classNames(["Overlay-container", containerClassName])} onClick={stopPropagation}>
      {!hideBackground && <div className="Overlay-background" onClick={closeBackground == true ? onClick : undefined}></div>}
      <div className={classNames(["Overlay-content", style, className])}>
        {title && <OverlayTitle closeCallback={closeCallback} hideClose={hideClose} title={title} />}
        {children}
      </div>
    </div>
  );
}

interface OverlayTitleProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  closeCallback?: any;
  hideClose?: boolean;
  style?: string;
  title: string;
  className?: string;
}

export function OverlayTitle({ closeCallback, hideClose, style, title }: OverlayTitleProps) {
  const onClick = useCallback(() => {
    if (closeCallback) {
      closeCallback(false);
    }
  }, [closeCallback]);
  return (
    <div className={classNames(["Overlay-title", style])}>
      {!hideClose && closeCallback && <CloseButton onClick={onClick} />}
      <span className="Overlay-title-text">{title}</span>
    </div>
  );
}
